import React, { useEffect } from "react";

//Externals
import HTMLReactParser from 'html-react-parser';

export function EmbeddedHtmlWidget(props) {
  const { ui, data } = props;
  const widgetId = ui.id;
  const content = data && data.content ? data.content : "";

  useEffect(() => {
    console.log("EmbeddedHtmlWidget data of " + ui.id + ": ", data);
  }, [data]);

  const containerStyle = {
    borderWidth: "1px",
    borderStyle: "solid",
    height: "100%",
    padding: "0.5em"
  };

  return (
    <div
      className={"dx-theme-border-color"}
      style={containerStyle}
      id={widgetId}
    >
      {HTMLReactParser(content)}
    </div>
  );
}